<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <button type="button" @click="back()" class="btn btn-default mb-10">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                </button>
            </div>
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="far fa-user"></i> Cliente
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Nome</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.usuario.nome"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>E-mail</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.usuario.email"
                                    />
                                </div>

                                <div class="col-md-4">
                                    <label>Data Nascimento</label>
                                    <input-datepicker
                                        :disabled="true"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.usuario.nascimento"
                                    ></input-datepicker>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>CPF</label>
                                    <masked-input
                                        mask="111.111.111-11"
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.usuario.cpf"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Telefone</label>
                                    <masked-input
                                        :readonly="model.id"
                                        v-model.trim="model.usuario.telefone"
                                        mask="(11) 11111-1111"
                                        class="form-control"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- APÓLICE -->
                    </div>
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-file-alt"></i> Apólice
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Contrato</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.contrato"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Plano</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.planoContratado"
                                    />
                                </div>

                                <div class="col-md-4">
                                    <label>Data Proposta</label>
                                    <input-datepicker
                                        :disabled="true"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.dataProposta"
                                    ></input-datepicker>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Início do serviço</label>
                                    <input-datepicker
                                        :disabled="true"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.dataInicio"
                                    ></input-datepicker>
                                </div>
                                <div class="col-md-4">
                                    <label>Nº de planos contratados</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.numeroPlanosContratados"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Forma de Pagamento</label>
                                    <input
                                        v-if="model.formaPagamento == 'S'"
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        value="Semanal"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Validade do serviço</label>
                                    <input
                                        v-if="model.validade == 'S'"
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        value="Mensal"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Renovação</label>
                                    <input
                                        v-if="model.renovacao == 'S'"
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        value="Semanal contra pagamento"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ENDEREÇO -->
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-map-marker-alt"></i> Endereço
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div class="col-md-3">
                                    <label>CEP*</label>
                                    <div class="input-group">
                                        <masked-input
                                            v-model.trim="model.usuario.endereco.cep"
                                            :readonly="model.id"
                                            mask="11111-111"
                                            class="form-control"
                                        />
                                        <div class="input-group-btn">
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                @click="searchCep()"
                                            >
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-6 col-xs-12">
                                    <label>Estado*</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.usuario.endereco.cidade.estado.nome"
                                    />
                                </div>

                                <div class="col-md-6 col-xs-12">
                                    <label>Cidade*</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.usuario.endereco.cidade.nome"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-6 col-xs-12">
                                    <label>Logradouro*</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="250"
                                        class="form-control"
                                        v-model="model.usuario.endereco.logradouro"
                                    />
                                </div>
                                <div class="col-md-2 col-xs-12">
                                    <label>Número*</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="model.usuario.endereco.numero"
                                    />
                                </div>
                                <div class="col-md-4 col-xs-12">
                                    <label>Complemento</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="45"
                                        class="form-control"
                                        v-model="model.usuario.endereco.complemento"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-6 col-xs-12">
                                    <label>Bairro*</label>
                                    <input
                                        :readonly="model.id"
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.usuario.endereco.bairro"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email,
    formatCep
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Collections from "@/helpers/collections";
import Select from "../../../components/Input/Select";
import Select2 from "../../../components/Input/Select2";
import FileImage from "../../../components/Input/FileImage";
import SelectApi from "../../../components/Input/SelectApi";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

export default {
    components: { Select2, FileImage, SelectApi, flatPickr, Select },
    data() {
        return {
            model: {
                usuario: {
                    nome: "",
                    endereco: {
                        cep: "",
                        cidade: {
                            nome: "",
                            estado: {
                                nome: ""
                            }
                        }
                    }
                }
            },

            file: null,
            config: {
                wrap: true,
                enableTime: false,
                time_24hr: false,
                locale: Portuguese,
                altInput: true,
                altFormat: "d/m/Y ",
                allowInput: true,
                maxDate: new Date()
            }
        };
    },

    methods: {
        back() {
            this.$router.push({
                name: "list-policies",
                params: {
                    idCPolicy: this.$route.params.idPolicy
                }
            });
        },

        throwError(e) {
            this.$notify.error("Erro!", e);
        },

        setData(policy) {
            let vm = this;
            if (policy !== undefined && policy !== null) {
                this.model = policy;
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        let vm = this;
        let response = null;

        if (to.params.idPolicy) {
            response = (await facade.getPolicy(to.params.idPolicy)).data.data;
        }

        next(vm => vm.setData(response));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?48fc3b07